import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import './Blog.css'; // Stil için blog stillerini kullanabiliriz

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
      const apiUrl = isLocal ? `http://${window.location.hostname}:3001/api/login` : '/api/login';

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token); // Token'ı kaydet
        navigate('/admin'); // Admin paneline yönlendir
      } else {
        setError('Giriş başarısız. Kullanıcı adı veya şifre hatalı.');
      }
    } catch (err) {
      setError('Sunucu hatası.');
    }
  };

  return (
    <div className="page admin-page">
      <Helmet>
        <title>Login - TA2GBO</title>
      </Helmet>
      <h2>Admin Girişi</h2>
      <form onSubmit={handleLogin} className="admin-form">
        <div className="form-group">
          <label>Kullanıcı Adı</label>
          <input 
            type="text" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label>Şifre</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <button type="submit" className="btn btn-primary">Giriş Yap</button>
        {error && <p className="admin-message" style={{backgroundColor: '#ffebee', color: '#c62828'}}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;